export const DEFAULT_ALLOWED_REFERRAL_NUMBER = 10

export const hasReachedReferralLimit = (referallsAvailble: number): boolean => referallsAvailble <= 0

/**
 * This function is used to get the number of generated referral stats value
 * and return the remaining value
 */
export const getReferralStatsValue = (referralStatsValue: number): number => {
  const isValidReferralLimit = referralStatsValue >= 0 && referralStatsValue <= DEFAULT_ALLOWED_REFERRAL_NUMBER
  const results = isValidReferralLimit ? DEFAULT_ALLOWED_REFERRAL_NUMBER - referralStatsValue : 0

  return results
}
